'use strict';

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var axios = require('axios');
const _BaseURL = {
  prod: "https://personalize.mat.cimpress.io/",
  stg: "https://int-personalize.mat.cimpress.io/"
};
async function _getRecommendationsPromise(payload, token, isStageEnvironment) {
  // const queryParams = Object.keys(payload).map((key) => (`${key}=${payload[key]}`))
  // const URL = `${_productRecommendationApiBaseURL}v2/personalize?${queryParams.join('&')}`;
  const {
    upSell
  } = payload;
  delete payload.upSell;
  const requestPayload = {
    queryStringParameters: _objectSpread({}, payload),
    upSell
  };
  const URL = "".concat(isStageEnvironment ? _BaseURL.stg : _BaseURL.prod, "v2/personalize");
  const headers = {
    "content-type": "application/json",
    "tenant": payload['tenant'],
    "Authorization": "Bearer ".concat(token)
  };
  return axios.post(URL, requestPayload, {
    headers: headers
  });
}
async function _updateMetricPromise(tenant, token, body, isStageEnvironment) {
  const URL = "".concat(isStageEnvironment ? _BaseURL.stg : _BaseURL.prod, "v2/recordMetric");
  const headers = {
    "content-type": "application/json",
    "Authorization": "Bearer ".concat(token),
    tenant
  };
  return axios.post(URL, {
    metrics: body
  }, {
    headers: headers
  });
}
module.exports = {
  /**
   * @function
   * @param {Object} payload Tenant information and related data for requesting recommendations
   * @param {string} payload.tenant
   * @param {string} payload.lob
   * @param {string} payload.anonymousId
   * @param {string} payload.customerId
   * @param {string} payload.locale 
   * @param {string} [payload.placementId] Placement ID. If this is provided, channel and location can be skipped
   * @param {string} [payload.channels] Placement channel for which recommendations are being requested for
   * @param {string} [payload.locations] Placement location or page for which recommendations are being requested for
   * @param {string} [payload.productsOnPage] Products user is seeing on the page
   * @param {string} [payload.productsInCart] Products in user's cart
   * @param {Object} [payload.upSell] Parameters required for up sell
   * @param {Object} [payload.upSell.selection] Product's attribute payload as per user selection (same as what's sent to Pricing API)
   * @param {Object} [payload.upSell.pricingPayload] Pricing response from ECommerce Pricing API
   * @param {Boolean} [payload.upSell.calculateTax] Governs if taxation related up-sell calculations are required or not
   * @param {Object} authInfo Authorization Info
   * @param {string} authInfo.token Authentication Token
   * @param {boolean} isStageEnvironment Flag to use the Integration/Stage environment of recommendations
  */
  getRecommendations: async (payload, authInfo, isStageEnvironment) => {
    let token;
    if (authInfo['token']) {
      token = authInfo['token'];
    } else {
      let response = {
        status: 'FAILED',
        message: 'Authentication Token missing'
      };
      throw new Error(response);
    }
    if (!payload['lob'] || !payload['tenant']) {
      let response = {
        status: 'FAILED',
        message: 'Key Fields Missing: Please check lob and tenant'
      };
      console.error(response.message);
      throw new Error(response);
    }
    if (!payload['placementId']) {
      if (!payload['channels'] || !payload['locations']) {
        let response = {
          status: 'FAILED',
          message: 'Key Fields Missing: Either placementId or (channels and locations) are missing'
        };
        console.error(response.message);
        throw new Error(response);
      }
    }
    try {
      let response = await _getRecommendationsPromise(payload, token, isStageEnvironment);
      return response.data;
    } catch (error) {
      console.error("Error in getting recommendations:: MESSAGE->".concat(error.message, " :: URL->").concat(error.config.url, " METHOD->").concat(error.config.method));
    }
    ;
  },
  /**
   * @function
   * @param {Object} payload Tenant information and related data
   * @param {string} payload.token Authentication Token
   * @param {string} payload.tenant 
   * @param {boolean} isStageEnvironment Flag to use the Integration/Stage environment of recommendations
   */
  updateMetric: (payload, isStageEnvironment) => {
    let token = payload['token'],
      tenant = payload['tenant'],
      body = {};
    for (const [key, value] of Object.entries(payload)) {
      if (key !== 'tenant' && key !== 'token') {
        body[key] = value;
      }
    }
    return _updateMetricPromise(tenant, token, body, isStageEnvironment);
  }
};